/* kult-b2b-service.js — mitlaufende Leiste der Firmenkunden-Startseite (sections/kult-b2b-jump.liquid, [data-kult-b2b-rail]).
   Zeigt die Leiste ab 960 px, sobald das Inhaltsverzeichnis oben aus dem Bild ist, bis die letzte Leistung durch ist;
   markiert die Leistung im Blick mit aria-current und setzt den Fortschritt (--kult-b2b-progress) für die Goldlinie.
   Scroll-Ereignisse per Capture, damit auch ein anderer Scroll-Container als das Fenster erfasst wird. Kein Framework. */
(function () {
  function init(rail) {
    if (!rail || rail.dataset.kultRailReady) return;
    rail.dataset.kultRailReady = '1';
    var jump = rail.closest('.kult-b2b-jump');
    var links = Array.prototype.slice.call(rail.querySelectorAll('.kult-b2b-jump__rail-link[href^="#"]')).filter(function (a) {
      return a.getAttribute('href').length > 1 && document.getElementById(a.getAttribute('href').slice(1));
    });
    if (!jump || !links.length) return;
    var targets = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
    var header = document.querySelector('.kult-header');
    var wide = window.matchMedia('(min-width: 960px)');
    var ticking = false;
    var current = -1;

    function update() {
      ticking = false;
      if (!wide.matches) { rail.classList.remove('is-active'); return; }
      var vh = window.innerHeight;
      var top = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
      rail.style.setProperty('--kult-b2b-rail-top', top + 'px');
      var first = targets[0].getBoundingClientRect();
      var last = targets[targets.length - 1].getBoundingClientRect();
      var show = jump.getBoundingClientRect().bottom <= top + (rail.offsetHeight || 64) + 2 && last.bottom > vh * 0.4;
      rail.classList.toggle('is-active', show);
      var line = vh * 0.4;
      var idx = -1;
      targets.forEach(function (t, i) { if (t.getBoundingClientRect().top <= line) idx = i; });
      if (idx !== current) {
        current = idx;
        links.forEach(function (a, i) { if (i === idx) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
      }
      var total = last.bottom - first.top;
      var p = total > 0 ? Math.min(1, Math.max(0, (line - first.top) / total)) : 0;
      rail.style.setProperty('--kult-b2b-progress', p.toFixed(4));
    }
    function request() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
    document.addEventListener('scroll', request, { passive: true, capture: true });
    window.addEventListener('resize', request);
    if (wide.addEventListener) wide.addEventListener('change', request);
    update();
  }
  function boot(root) { (root || document).querySelectorAll('[data-kult-b2b-rail]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { if (e.target && e.target.querySelectorAll) boot(e.target); });
})();
